<h1>Playlist</h1>
<p>Play all your favorite songs in order</p>

@if (tracks().length > 0) {
@let current = tracks()[currentTrackIndex()];
<!-- Currently Playing Section -->
<div class="player-section" fxLayout="column" fxLayoutAlign="center center">
  <mat-card class="now-playing-card">
    <!-- Album Art Background -->
    @if (current?.album?.images?.[0]?.url) {
    <div class="album-art" [style.backgroundImage]="'url(' + current.album.images[0].url + ')'"></div>
    } @else {
    <div class="album-art album-art-placeholder"></div>
    }

    <!-- Player Overlay -->
    <div class="player-overlay" fxLayout="column" fxLayoutAlign="center center">
      <h2 class="track-title">{{current?.name}} <app-deezer-link kind="track" [id]="current.id" [name]="current.name" /></h2>
      <p class="track-artist">
        @for (a of current?.artists; track a.id) {
        <a [routerLink]="['/artist', a.id]">{{a.name}}</a>{{!$last ? ', ' : ''}}
        }
      </p>

      <!-- Control Buttons -->
      <div class="controls" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="12px">
        <button mat-icon-button (click)="previousTrack()" [disabled]="currentTrackIndex() === 0" class="control-btn">
          <mat-icon>skip_previous</mat-icon>
        </button>

        <button mat-icon-button (click)="togglePlayPause()" class="play-btn" [disabled]="!current?.preview_url">
          <mat-icon class="large-icon">{{isPlaying() ? 'pause' : 'play_arrow'}}</mat-icon>
        </button>

        <button mat-icon-button (click)="nextTrack()" [disabled]="currentTrackIndex() === tracks().length - 1" class="control-btn">
          <mat-icon>skip_next</mat-icon>
        </button>

        <button mat-icon-button (click)="togglePictureInPicture()" class="control-btn" title="Pop-out Player">
          <mat-icon>open_in_new</mat-icon>
        </button>

        <div class="volume-container" fxLayout="row" fxLayoutAlign="center center">
          <button mat-icon-button (click)="toggleVolumeSlider()" class="control-btn" title="Volume">
            <mat-icon>{{volume() === 0 ? 'volume_off' : volume() < 0.5 ? 'volume_down' : 'volume_up'}}</mat-icon>
          </button>
          @if (showVolumeSlider()) {
          <input type="range" min="0" max="1" step="0.01" [value]="volume()" (input)="setVolume($any($event).target.value)" class="volume-slider" />
          }
        </div>
      </div>

      <!-- Progress Bar (Optional) -->
      <div class="progress-info" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
        <span class="time">{{formatTime(currentTime())}}</span>
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="duration() ? (currentTime() / duration()) * 100 : 0"></div>
        </div>
        <span class="time">{{formatTime(duration())}}</span>
      </div>

      @if (!current?.preview_url) {
      <p class="no-preview"><em>No preview available</em></p>
      }
    </div>
  </mat-card>
</div>

<!-- Upcoming Tracks Section -->
<div class="upcoming-section">
  <h3>Up Next ({{tracks().length - currentTrackIndex() - 1}} tracks)</h3>

  <div fxLayout="row wrap" fxLayoutGap="8px">
    @for (track of tracks(); let i = $index; track track.id) {
    @if (i > currentTrackIndex()) {
    <div fxFlex="100" fxFlex.gt-xs="50" fxFlex.gt-sm="calc(33.333% - 6px)">
      <mat-card class="track-card" [class.current]="i === currentTrackIndex()" (click)="skipToTrack(i)">
        <mat-card-header class="track-header">
          <span class="track-number">{{i + 1}}</span>
          <mat-icon (click)="removeFromPlaylist(track.id); $event.stopPropagation();" class="remove-btn" title="Remove from favorites">clear</mat-icon>
          <span class="track-name truncate" title="{{track.name}}">{{track.name}}</span>
        </mat-card-header>
        <mat-card-content class="track-meta">
          <p class="artist truncate">
            @for (a of track.artists; track a.id) {
            <a [routerLink]="['/artist', a.id]">{{a.name}}</a>{{!$last ? ', ' : ''}}
            }
          </p>
          <p class="duration">{{(track.duration_ms / 60000).toFixed(2)}} min</p>
        </mat-card-content>
      </mat-card>
    </div>
    }
    }
  </div>
</div>

} @else {
<mat-card>
  <mat-card-content>
    <p>No favorites yet. Add songs to favorites to create a playlist.</p>
  </mat-card-content>
</mat-card>
}
<br /><br />
